import React from "react";
import slugify from "slugify";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Container, Link, Actions } from "./styles";
import { FaRegClone } from "react-icons/fa";
import Button from "@material-ui/core/Button";

export default function LinkInput(props) {
  const pre = "menu.mindi.com.br/";
  const slug = props.value.split("/")[1];

  const [url, setUrl] = React.useState(pre + slug);

  function handleChange(ev) {
    ev.target.value = pre + slugify(ev.target.value.toLowerCase());
    props.onChange(ev);
    setUrl(pre + slugify(ev.target.value.toLowerCase()));
  }

  return (
    <Container>
      <span>{pre}</span>
      <input
        {...props}
        onChange={handleChange}
        value={slug}
        autoComplete="off"
      />
      <Actions>
        <Link href={"https://" + url} target="_blank">
          Testar link
        </Link>
        <CopyToClipboard
          text={"https://" + url}
          onCopy={() => {
            alert("Link copiado!");
          }}
        >
          <Button color="primary">
            <FaRegClone size="18px" />
          </Button>
        </CopyToClipboard>
      </Actions>
    </Container>
  );
}
